<script>
import { event } from "vue-analytics";
import Modal from "@/components/_Shared/Modal";

export default {
  name: "Home",
  components: {
    Modal
  },
  data() {
    return {
      showProductsList: false
    };
  },
  methods: {
    clickedOnScheduleCleanup() {
      event("cliente", "click", "Inicial:agendarlimpeza");
    }
  }
};
</script>

<template>
  <div class="container">
    <div class="row">
      <div class="card align-center">
        <h1>
          Você está na
          <b>Donamaid</b>.
        </h1>
        <h1>Bem-vindo(a) à nova forma de contratar faxinas!</h1>
        <router-link @click="clickedOnScheduleCleanup" :to="{name: 'purchase-flow'}">
          <button class="btn bg-purple mt-20">agendar limpeza</button>
        </router-link>
      </div>
    </div>

    <div class="row text-center">
      <div class="card pt-50">
        <i class="icon shield-checked"></i>
        <div class="card-title">Profissionais</div>
        <p
          class="mt-5"
        >Os profissionais na plataforma donamaid são experientes, amigáveis e com antecedentes verificados.</p>
      </div>

      <div class="card pt-50">
        <i class="icon sprinkler"></i>
        <div class="card-title">Produtos</div>
        <p class="mt-5">
          Os profissionais levam os produtos para a limpeza. Mas se você preferir usar os seus, tudo bem.
          <small
            class="text-purple pointer"
            @click="showProductsList = true"
          >
            <b>Ver os produtos</b>
          </small>
        </p>
      </div>

      <div class="card pt-50">
        <i class="icon clock"></i>
        <div class="card-title">Faxinas na medida</div>
        <p
          class="mt-5"
        >Agende de forma fácil, limpezas de vários tamanho, inclusive para o dia seguinte.</p>
      </div>
    </div>

    <modal
      v-if="showProductsList"
      title="LISTA DE PRODUTOS"
      size="md"
      @close="showProductsList = false"
    >
      <template slot="body">
        <div>
          A lista de produtos varia de cada profissional, mas todos eles levam, no mínimo, os seguintes ítens:
          <ul>
            <li>(500ml) Desinfetante de uso geral</li>
            <li>(200ml) Limpador multiuso</li>
            <li>(200ml) Detergente</li>
            <li>(200ml) Álcool líquido 70%</li>
            <li>(100ml) Lustra móveis</li>
            <li>(1 litro) Água sanitária</li>
            <li>(1 par) de Luvas de borracha</li>
            <li>(4) Panos de chão</li>
            <li>(6) Flanelas</li>
            <li>(1) Esponja</li>
            <li>(1) Esponja de aço</li>
            <li>(3) Sacos de lixo</li>
            <li>(1) Pincel</li>
          </ul>
        </div>
      </template>
      <template slot="footer">
        <button class="btn bg-purple-outline" @click="showProductsList = false">fechar</button>
      </template>
    </modal>
  </div>
</template>

<style scoped>
h1 {
  font-size: 32px;
  margin: 5px 0;
  font-weight: 400;
  text-align: center;
}

.card-title {
  margin-top: 15px;
  font-weight: 400;
  font-size: 26px;
}

.icon {
  height: 96px;
}

.shield-checked {
  background: url("../../static/shield-checked.svg") no-repeat center;
}

.sprinkler {
  background: url("../../static/sprinkler.svg") no-repeat center;
}

.clock {
  background: url("../../static/clock.svg") no-repeat center;
}

.btn {
  padding: 15px 50px;
}

@media (max-width: 992px) {
  h1 {
    font-size: 24px;
  }
  .row {
    flex-direction: column !important;
  }

  .row .card:first-child {
    margin-left: 10px !important;
  }

  .row .card:last-child {
    margin-right: 10px !important;
  }

  .btn {
    padding: 15px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue